import React from 'react';

const LoadingState = ({ viewMode = 'grid' }) => {
  const SkeletonCard = () => (
    <div className="bg-card border border-border rounded-lg p-4 animate-pulse">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          <div className="w-4 h-4 bg-muted rounded" />
          <div className="w-12 h-12 bg-muted rounded-lg" />
        </div>
        <div className="w-16 h-6 bg-muted rounded-full" />
      </div>
      
      <div className="space-y-3">
        <div>
          <div className="w-3/4 h-5 bg-muted rounded mb-2" />
          <div className="w-1/2 h-4 bg-muted rounded" />
        </div>
        
        <div className="flex items-center justify-between">
          <div className="w-20 h-4 bg-muted rounded" />
          <div className="w-16 h-4 bg-muted rounded" />
        </div>
        
        <div className="w-full h-4 bg-muted rounded" />
        <div className="w-2/3 h-3 bg-muted rounded" />
      </div>
      
      <div className="flex items-center justify-between mt-4 pt-3 border-t border-muted">
        <div className="flex space-x-2">
          <div className="w-16 h-8 bg-muted rounded" />
          <div className="w-16 h-8 bg-muted rounded" />
        </div>
        <div className="w-20 h-8 bg-muted rounded" />
      </div>
    </div>
  );

  const SkeletonTableRow = () => (
    <tr className="animate-pulse">
      <td className="px-4 py-3">
        <div className="flex items-center space-x-3">
          <div className="w-4 h-4 bg-muted rounded" />
          <div className="w-10 h-10 bg-muted rounded-lg" />
        </div>
      </td>
      <td className="px-4 py-3">
        <div className="space-y-2">
          <div className="w-32 h-4 bg-muted rounded" />
          <div className="w-24 h-3 bg-muted rounded" />
        </div>
      </td>
      <td className="px-4 py-3">
        <div className="w-20 h-4 bg-muted rounded" />
      </td>
      <td className="px-4 py-3">
        <div className="w-12 h-4 bg-muted rounded" />
      </td>
      <td className="px-4 py-3">
        <div className="w-16 h-6 bg-muted rounded-full" />
      </td>
      <td className="px-4 py-3">
        <div className="flex space-x-2">
          <div className="w-8 h-8 bg-muted rounded" />
          <div className="w-8 h-8 bg-muted rounded" />
          <div className="w-8 h-8 bg-muted rounded" />
        </div>
      </td>
    </tr>
  );

  if (viewMode === 'table') {
    return (
      <div className="bg-card border border-border rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-muted/30 border-b border-border">
            <tr>
              <th className="px-4 py-3 text-right">
                <div className="w-16 h-4 bg-muted rounded animate-pulse" />
              </th>
              <th className="px-4 py-3 text-right">
                <div className="w-20 h-4 bg-muted rounded animate-pulse" />
              </th>
              <th className="px-4 py-3 text-right">
                <div className="w-16 h-4 bg-muted rounded animate-pulse" />
              </th>
              <th className="px-4 py-3 text-right">
                <div className="w-20 h-4 bg-muted rounded animate-pulse" />
              </th>
              <th className="px-4 py-3 text-right">
                <div className="w-16 h-4 bg-muted rounded animate-pulse" />
              </th>
              <th className="px-4 py-3 text-right">
                <div className="w-20 h-4 bg-muted rounded animate-pulse" />
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 8 })?.map((_, index) => (
              <SkeletonTableRow key={index} />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {Array.from({ length: 8 })?.map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  );
};

export default LoadingState;